export default "__VITE_ASSET__aafb9193__"